import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <RankingSection />
        <IndexSection />
        <AboutSection />
        <CardsSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
        <CarouselSection />
        <TopicsSection />
        <FAQSection />
        <MediaSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}